function maxFileSize() {
  const element = document.getElementById("m-f-s");
  if (element) {
    const value = element.getAttribute("data-v");
    const maxSizeInBytes = Number(value);
    return maxSizeInBytes;
  } else {
    return 0;
  }
}

function fileTooBigForQuotaAvailable(file) {
  const element = document.getElementById("r-q");
  if (element) {
    const value = element.getAttribute("data-v");
    const totalSizeInBytes = Number(value);
    return file.size > totalSizeInBytes;
  } else {
    return false;
  }
}

const ALLOWED_FILE_TYPES = [
  "image/png",
  "image/jpg",
  "image/gif",
  "image/jpeg",
  "image/svg+xml",
  "image/webp",
  "image/bmp",
  "image/tiff",
  "video/mp4",
  "video/quicktime",
  "video/x-msvideo",
  "video/x-ms-wmv",
  "video/x-flv",
  "video/ogg",
  "video/webm",
  "video/vnd.youtube.yt",
  "text/plain",
  "text/csv",
  "text/css",
  "text/markdown",
  "text/rtf",
  "text/xml",
  "audio/vorbis",
  "audio/mpeg",
  "audio/mp4",
  "audio/ogg",
  "audio/wav",
  "audio/webm",
  "audio/x-ms-wma",
  "audio/flac",
  "application/pdf",
  "application/rtf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/xml",
  "application/json",
  "application/application/xslt+xml",
  "application/yaml",
  "application/sql",
  "application/soap+xml",
];

function isAllowedFileType(fileType) {
  return ALLOWED_FILE_TYPES.some((allowedType) => {
    if (allowedType.endsWith("/*")) {
      return fileType.startsWith(allowedType.slice(0, -2));
    }
    return allowedType === fileType;
  });
}

export function validateFile(file) {
  if (!isAllowedFileType(file.type)) {
    document.getElementById("file-type-error").classList.remove("hidden");
    throw new Error("File type not allowed.");
  }
  if (file.size > maxFileSize()) {
    document.getElementById("file-size-error").classList.remove("hidden");
    throw new Error("File size exceeds limit.");
  }
  if (fileTooBigForQuotaAvailable(file)) {
    document.getElementById("file-quota-error").classList.remove("hidden");
    throw new Error("File size exceeds available quota.");
  }
}
